import { useQuery } from '@tanstack/react-query';

import { User } from 'common/api/api-types';
import { deliveryOsGatewayApiAgent } from 'common/api/apiAgents';
import queryKeys from 'common/hooks/queryKeys';
import { decodeHttpResponse } from 'common/utils/apiUtils';

const fetchUserInfo = () => decodeHttpResponse(User, deliveryOsGatewayApiAgent.get('/user'));

const useUserInfo = () =>
  useQuery({
    queryKey: queryKeys.forUseUserInfo(),
    queryFn: () => fetchUserInfo(),
  });

export default useUserInfo;
